/* generated via
ddata = domainctrl.ddata
x = {}
for t in vl.states.activeStateTypes[ddata.name]:
    x[t] = {}
    for k, v in vl.states.getStatesJson(t).items():
        x[t][k] = v['value']
*/ export const STATE_NAME2VALUE = {
    segmentizer: {
        applied: '6',
        undefined: '0',
        deferred: '2',
        processing: '4',
        presegmented: '5',
        failed: '7',
        presegmented_good: '11',
        presegmented_ok: '12',
        presegmented_superb: '10',
        presegmented_bad: '13',
        pending: '1'
    },
    wf: {
        structuring_finished: '1',
        structuring_open: '-2',
        structuring_not_necessary: '-1',
        miscellaneous: '6',
        deferred: '8',
        structuring_deepen: '0',
        metadata_revise: '7',
        quality_losses_by_Original: '5'
    },
    qs: {
        redundant_images: '11',
        images_missing: '6',
        in_digitization: '-8',
        icc_incorrect: '-4',
        not_digitizable: '-11',
        order_given: '-10',
        miscellaneous: '12',
        approved: '1',
        not_approval_relevant: '8',
        deferred: '-12',
        auto_qa_failed: '-1',
        metadata_available: '-9',
        in_editing: '0',
        in_qa: '-7',
        colorchecker_incorrect: '3',
        image_formats_incorrect: '-2',
        images_incorrect: '5',
        structure_incorrect: '4',
        check: '2',
        approved_open: '13'
    },
    pageqa: {
        incorrect: '11',
        lossy_ok: '101',
        bpp_fail: '5',
        icc_fail: '4',
        size_limit_fail: '7',
        lossy_miss: '103',
        dpi_fail: '2',
        ignore: '10',
        corrupt: '1',
        size_fail: '3',
        passed: '8',
        lossy_bad: '102',
        lossy_good: '100',
        mime_fail: '6',
        undefined: '0'
    },
    apipush_obvurn: {
        retry_register: '9',
        register: '4',
        update_failed: '6',
        undefined: '0',
        skip_register: '1',
        registered: '5',
        needs_attention: '2',
        update: '3',
        registration_failed: '7',
        retry_update: '8'
    },
    pdfcutter: {
        success_pages_toc: '7',
        success_pages_text: '8',
        undefined: '0',
        success_pages_text_toc: '9',
        processing: '4',
        deferred: '2',
        success_pages: '6',
        fail: '5',
        pending: '1',
        blocked: '3'
    },
    gndsync: {
        fail: '3',
        pending: '1',
        undefined: '0',
        success: '2'
    },
    srusync: {
        fail: '3',
        pending: '1',
        undefined: '0',
        success: '2'
    },
    ar: {
        readerrestricted: '7',
        librarywide: '3',
        restricted: '5',
        reader: '6',
        libraryrestricted: '4',
        campuswide: '2',
        fulltextrestricted: '9',
        readerremote: '8',
        public: '1'
    },
    apipush_obvidn: {
        retry_register: '9',
        register: '4',
        update_failed: '6',
        undefined: '0',
        skip_register: '1',
        registered: '5',
        needs_attention: '2',
        update: '3',
        registration_failed: '7',
        retry_update: '8'
    },
    release: {
        released: '1',
        retracted: '2',
        unreleased: '0'
    },
    sb: {
        transfer_checkedin: '10',
        archived: '2',
        suspended: '5',
        transfered: '7',
        transfer_rejected: '9',
        transfer_active: '6',
        images_deleted: '4',
        delete_images: '3',
        new: '0',
        removed: '1',
        transfer_failed: '8'
    },
    zmods_export: {
        skip: '1',
        export: '2',
        undefined: '0'
    },
    // XXX: is called `ocr` in OPR_Status but maps to `ocrstate` column namespace
    ocrstate: {
        undefined: '0',
        success: '6',
        deleted: '9',
        processing: '4',
        deferred: '2',
        usepattern: '3',
        excluded: '8',
        fail: '5',
        success_warnings: '7',
        pending: '1'
    },
    zipcapsule: {
        abandoned: '-1',
        verify: '0',
        create: '1',
        start: '2',
        suspended: '8',
        error: '6',
        create_delta: '7'
    },
    zmods_validation: {
        valid_warn: '2',
        skipped_invalid: '4',
        valid: '3',
        invalid: '1',
        undefined: '0'
    },
    apipush_datacite: {
        retry_register: '9',
        register: '4',
        update_failed: '6',
        undefined: '0',
        skip_register: '1',
        registered: '5',
        needs_attention: '2',
        update: '3',
        registration_failed: '7',
        retry_update: '8'
    },
    metadata: {
        available: '2',
        unchecked: '9',
        incomplete: '1',
        complete: '3'
    },
    license: {
        reserved: '15',
        'vgwort-51': '16',
        NKC_1: '31',
        'NoC-OKLR_1': '22',
        'cc-by-nd_4': '5',
        'cc-by-nc_4': '6',
        'cc-by-nc_3': '12',
        'cc-by-nc_2': '43',
        'cc-by-nd_2': '42',
        'cc-by-nd_3': '11',
        'cc-by_2': '40',
        'cc-by_3': '9',
        'cc-by_4': '3',
        'cc-by-sa_2': '41',
        'cc-by-sa_3': '10',
        cc0: '2',
        'cc-by-sa_4': '4',
        'cc-by-nc-sa_4': '7',
        'cc-by-nc-sa_3': '13',
        'cc-by-nc-sa_2': '44',
        'NoC-NC_1': '21',
        'cc-by-nc-nd_3': '14',
        'cc-by-nc-nd_2': '45',
        'NoC-CR_1': '20',
        'InC-RUU_1': '28',
        'cc-by-nc-nd_4': '8',
        'InC-EU-OW_1': '25',
        'InC-EDU_1': '26',
        undefined: '0',
        WISOM_Std_1: '50',
        'InC-NC_1': '27',
        pdm: '1',
        CNE_1: '29',
        UND_1: '30',
        InC_1: '24'
    }
};
